<template>
  <dialog-template 
    :headerTitle="mode === 'on' ? '上架商品' : '下架商品'" 
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :width="'400px'">
    <p v-if="mode === 'on'" class="question">
        <span v-if="goodsNum > 1">确定上架当前选中的<span> {{ goodsNum }} </span>种商品吗？</span>
        <span v-else>确定上架架商品 {{ goodsName }} 吗？</span>
    </p>
    <p v-else class="question text-popper" v-textPopper>
        <span v-if="goodsNum > 1">确定下架当前选中的<span> {{ goodsNum }} </span>种商品吗？</span>
        <span v-else>确定下架商品 {{ goodsName }} 吗？</span>
    </p>
    <p v-if="mode === 'on'" class="tips">下架商品上架后将可再次出售</p>
    <p v-else class="tips">下架后商品将不可出售</p>
    <div class="btn-wrapper" slot="footer">
        <el-button :loading="isOnSubmit" type="primary" size="medium" @click="confirm">确认</el-button>
        <el-button type="default" size="medium" @click="dialogVisible = false">取消</el-button>
    </div>
  </dialog-template>
</template>

<script lang="ts">
import { createComponent, ref, computed } from '@vue/composition-api'
import { $fetch } from '@/api/index'
import { openMessage } from '@/utils/system.tsx'

// import DialogTemplate from "./dialog_template";
export default createComponent({
    setup() {
        const dialogVisible = ref(false)
        const goodsNum = ref<number | undefined>(0)
        const goodsIds = ref<number[] | undefined>()
        const groupId = ref<number | undefined>()
        const secondaryGroupId = ref<number | undefined>()
        const isOnSubmit = ref(false)
        const mode = ref('')
        const goodsName = ref<string | undefined>('')
        let confirmCallback = () => {}

        function open(options: {
            mode: 'off' | 'on'
            goods_num?: number,
            goods_ids?: number[],
            group_id?: number,
            goods_name?: string,
            secondary_group_id?: number,
            callback: () => void
        }) {
            mode.value = options.mode
            goodsIds.value = options.goods_ids
            groupId.value = options.group_id
            secondaryGroupId.value = options.secondary_group_id
            goodsNum.value = options.goods_num
            goodsName.value = options.goods_name
            confirmCallback = options.callback
            dialogVisible.value = true
        }

        function confirm() {
            if (isOnSubmit.value) {
                return
            }
            isOnSubmit.value = true
            $fetch.post({
                url: '/goods/editgoodsstatus',
                params: {
                    goods_ids: goodsIds.value,
                    group_id: groupId.value,
                    secondary_group_id: secondaryGroupId.value,
                    status: mode.value === 'on' ? 0 : 1
                }
            }).then(data => {
                openMessage('success', mode.value === 'on' ? '上架成功' : '下架成功')
                confirmCallback()
                dialogVisible.value = false
            }).catch(e => {
                openMessage('error', e.message)
            }).finally(() => {
                isOnSubmit.value = false
            })
        }

        return {
            goodsNum,
            mode,
            goodsIds,
            goodsName,
            dialogVisible,
            open,
            confirm,
            isOnSubmit
        }
    }
})
</script>

<style lang="scss" scoped>
p {
    text-align: center;
}

.question {
    height: 20px;
    line-height: 20px;
    color: #333;
    font-size: 16px;
    font-weight: 500;

    span {
        font-weight: bold;
    }
}

.tips {
    height: 16px;
    line-height: 16px;
    margin-top: 8px;
    font-size: 14px;
    color: #666;
}

.btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
